/* eslint-disable */

let menu = []
const role = JSON.parse(localStorage.getItem('DuttonAuthUser')).role

// switch case with role
switch (role) {
  case 'admin':
    menu = [
      {
        header: 'Menú',
      },
      {
        title: 'Inicio',
        route: 'home',
        icon: 'HomeIcon',
      },
      {
        title: 'Catálogos',
        icon: 'FolderIcon',
        children: [
          {
            title: 'Categorías',
            route: 'catalogs-categories',
          },
          {
            title: 'UOMs',
            route: 'catalogs-measure-units',
          },
          {
            title: 'Productos',
            route: 'catalogs-products',
          },
        {
          title: 'Inventario',
          route: 'catalogs-inventory',
        },
          /* {
            title: 'Listas de precios',
            route: 'price-lists',
          },
          {
            title: 'Regiones',
            route: 'catalogs-regions',
          },
          {
            title: 'Marcas',
            route: 'catalogs-brands',
          }, */
        ],
      },
      {
        title: 'Contactos',
        icon: 'UsersIcon',
        children: [
          {
            title: 'Clientes',
            route: 'contacts-customers',
          },
        ],
      },
      {
        title: 'Ventas',
        icon: 'BoxIcon',
        children: [
          {
            title: 'Cotizaciones',
            route: 'sales-customer-quotes',
          },
          {
            title: 'Pedidos',
            route: 'sales-customer-orders',
          },
        ],
      },
      {
        title: 'Sistema',
        icon: 'SettingsIcon',
        children: [
          {
            title: 'Usuarios',
            route: 'users',
          },
          /* {
            title: 'Actualizaciones',
            route: 'updates',
          }, */
        ],
      },
    ]
  break
  case'vendor':
    menu = [
      {
        header: 'Menú',
      },
      {
        title: 'Inicio',
        route: 'home',
        icon: 'HomeIcon',
      },
      {
        title: 'Catálogos',
        icon: 'FolderIcon',
        children: [
          {
            title: 'Productos',
            route: 'catalogs-products',
          },
        ],
      },
      {
        title: 'Contactos',
        icon: 'UsersIcon',
        children: [
          {
            title: 'Clientes',
            route: 'contacts-customers',
          },
        ],
      },
      {
        title: 'Ventas',
        icon: 'BoxIcon',
        children: [
          {
            title: 'Cotizaciones',
            route: 'sales-customer-quotes',
          },
          {
            title: 'Pedidos',
            route: 'sales-customer-orders',
          },
        ],
      },
    ]
  break
  default:
    menu = []
    break
}
        
export default menu
/* eslint-disable */
